import React from 'react';

export interface FundingHistoryData {
	date: string;
	method: string;
	fee: string;
	amount: string;
	action: any;
}

export const ColumnFundingHistory = [
	{
		Header: 'Method',
		accessor: 'method',
	},
	{
		Header: 'Amount',
		accessor: 'amount',
	},
	{
		Header: 'Fee',
		accessor: 'fee',
	},
	{
		Header: 'Date',
		accessor: 'date',
	},
	// {
	// 	Header: '',
	// 	accessor: 'action',
	// },
];
